function FeaturesDetailed() {
    const features = [
        {
            title: "Module: Blockchain Automation",
            description: "Blockchains are continuously being integrated to increase the degree of automation in transaction tracking and data preperation.",
            icon: "add-keyframes"
        },
        {
            title: "Modul: Graph of Transactions",
            description: "By visually representing dependencies between transactions, mapping is simplified and communication of the source of funds is facilitated.",
            icon: "graph-up"
        },
        {
            title: "Modul: Open Banking",
            description: "We enable mapping between fiat and crypto transactions, which allows seamless origin of funds and valuation of asset acquisition costs at any time.",
            icon: "bank"
        },
        {
            title: "Modul: Tokenized funds",
            description: "Tokenized crypto funds will grow strongly in the future, so we already offer first features like determining a daily price based on issued shares. .",
            icon: "xray-view"
        },
        {
            title: "Modul: ROI per Asset",
            description: "Identical assets can have different acquisition prices, so it's important to know which assets will yield the most return when sold or traded.",
            icon: "reply"
        },
        {
            title: "Modul: Individual Rules & Alerts",
            description: "With individual rules and signals you can react faster to events around your portfolio and initiate necessary actions.",
            icon: "message-alert"
        },
        {
            title: "Modul: Cashflow Visualisation",
            description: "See at a glance what returns you've achieved through cash flow strategies like staking.",
            icon: "lot-of-cash"
        },
        {
            title: "Modul: Extended Workflows",
            description: "Our advanced workflows are designed to help you automate administrative tasks and reduce errors and time.",
            icon: "path-arrow"
        },
        {
            title: "Modul: Data Preperation",
            description: "Data are needed for different scopes. With our data preparation module, we prepare this data for diffent cases.",
            icon: "stats-report"
        },
        {
            title: "Private API",
            description: "Seamless integration of our REST API for use in external environments.",
            icon: "data-transfer-both"
        },
        {
            title: "...and more is coming.",
            description: "We work closely with crypto funds and professional investors to constantly expand our feature set.",
            icon: "xray-view"
        }
    ];

    return (
        <div className="max-w-screen-xl box m-auto mb-32 max-xl:p-5">
            <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
                New moduls are coming 2023 🚀
            </h1>
            <p className="font-medium text-slate-400 mb-10">
            Our tool grows organically. New features are constantly emerging and new blockchain protocols will be supported.<br/> To keep up the pace, we always have an eye on the needs of our customers. <br/>This is just the beginning of our Journey!
                
            </p>
            <div className="flex justify-items-stretch flex-wrap">
                {
                    features.map((feature, i) => (
                        <div className="flex flex-row w-full sm:w-6/12 lg:w-4/12" key={"feature-" + i}>
                            <div className="m-1 border border-slate-200 rounded-xl p-5 hover:bg-slate-50 transition-colors cursor-default w-full">
                                <i className={"iconoir-" + feature.icon + " text-blue-600 block my-auto mr-4 text-4xl mb-3"}></i>
                                <div className="box my-auto w-10/12">
                                    <h2 className="font-semibold text-slate-800 text-left">
                                        {feature.title}
                                    </h2>
                                    <p className="text-slate-400 text-left">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default FeaturesDetailed;
